<ng-container
  *ngIf="{
    slot: slot$ | async
  } as data"
>
  <span *ngIf="data.slot" [title]="data.slot.title"></span>
</ng-container>
